import i18n, { InitOptions } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import { addBlokkieTranslations } from '@tikkie/blokkie';

import { debug } from '@/config';

import a11y_de from '../locales/a11y_de.json';
import a11y_en from '../locales/a11y_en.json';
import a11y_fr from '../locales/a11y_fr.json';
import a11y_nl from '../locales/a11y_nl.json';
import assets_de from '../locales/assets_de.json';
import assets_en from '../locales/assets_en.json';
import assets_fr from '../locales/assets_fr.json';
import assets_nl from '../locales/assets_nl.json';
import de from '../locales/de.json';
import en from '../locales/en.json';
import fr from '../locales/fr.json';
import nl from '../locales/nl.json';

i18n.on('languageChanged', (lng) => (document.documentElement.lang = lng));

export const i18nConfig: InitOptions = {
  ns: ['translation', 'a11y', 'assets'],
  fallbackLng: 'en',
  supportedLngs: ['nl', 'en', 'fr', 'de'],
  debug,
  resources: {
    en: { translation: en, a11y: a11y_en, assets: assets_en },
    nl: { translation: nl, a11y: a11y_nl, assets: assets_nl },
    fr: { translation: fr, a11y: a11y_fr, assets: assets_fr },
    de: { translation: de, a11y: a11y_de, assets: assets_de },
  },
  detection: {
    lookupLocalStorage: 'i18nextLng',
    order: ['localStorage', 'navigator'],
  },
};

i18n.use(LanguageDetector).use(initReactI18next).init(i18nConfig);
addBlokkieTranslations(i18n);
i18n.options.keySeparator = '.';
i18n.options.defaultNS = 'translation';

declare module 'i18next' {
  interface CustomTypeOptions {
    resources: {
      translation: typeof nl;
      a11y: typeof a11y_nl;
      assets: typeof assets_nl;
    };
  }
}

export default i18n;
